/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import { store } from 'src/state/store';

import Actions from 'src/state/root-actions';
import { saga as segment } from 'src/state/segment/sagas';

import 'src/styles/global.scss';
import 'pure-react-carousel/dist/react-carousel.es.css';
import * as REMOTE_CONFIG from './.remote_config.json'

export { default as wrapRootElement } from 'src/components/WrapRootElement';

export const onClientEntry = async () => {
    store.dispatch(Actions.initialPageLoad.trigger());

    if (typeof IntersectionObserver === `undefined`) {
        await import(`intersection-observer`);
    }

    // Wait for Datagrail to load to check if we should initialize 3rd party scripts
    window.dgEvent = window.dgEvent || []

    const onPrefsChange = () => {
        if (window.DG_BANNER_API.categoryEnabled('Functional')) {
        // Load Segment
        window?.analytics?.load(REMOTE_CONFIG.segment?.writeKey)
        // Set flag for Hotjar, loaded in packages/web/src/components/layout/Layout.tsx
        window.loadHotjar = true
      }
      else {
        window.loadHotjar = false
      }
    }

    // If DG already loaded by the time this runs
    if (window.DG_BANNER_API) {
      onPrefsChange();
    }

    // Triggered on DG init
    window.dgEvent.push({
      event: 'initial_preference_callback',
      params: onPrefsChange,
    })

    // Triggered on changes made in the consent dialog
    window.dgEvent.push({
      event: 'preference_callback',
      params: onPrefsChange,
    })
};

export const onRouteUpdate = ({ location }) => {
    segment.page(location.pathname);
}
